import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router ,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.less']
})
export class PreviewComponent implements OnInit {
  @Input() userData: any;
  @Output() routeEdit: EventEmitter<any> = new EventEmitter<any>();
  constructor(private router: Router, private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    
  }
  routeForEdit(data) {
    this.routeEdit.emit(data);
  }
}
